import { isProducerAction } from '../types/producer-action.types';
class ProducerActionService {
    create(action) {
        return JSON.stringify(action);
    }
    read(actionJson) {
        try {
            const action = JSON.parse(actionJson);
            if (isProducerAction(action)) {
                return action;
            }
            return new Error('Not a consumer action');
        }
        catch (err) {
            if (err instanceof Error) {
                return err;
            }
            return new Error('Unknown action read error');
        }
    }
}
export { ProducerActionService };
